import WebsiteModal from "modal/WebsiteModal";
import {handleHubspotForm} from "util/hubspot";

export default class AboutPersonModal extends WebsiteModal {
    constructor(data) {
        super();
        this.data = data;

        this.translations = {};

        if ($(".js-about-translations").length > 0) {
            try {
                this.translations = JSON.parse($(".js-about-translations").text());
            } catch (e) {
                console.warn("Couldn't load data from page", e);
            }
        }
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {class: "modal modal--steering-group"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('button', {className: "modal__close js-close-modal"}),
                    eotwJSXFactory('div', {className: "modal__images"}, [
                        eotwJSXFactory('div', {className: "modal__main-image", unsafeHtml: this.data.image}),
                        eotwJSXFactory('div', {className: "modal__image-text"}, [
                            eotwJSXFactory('h3', {className: "heading"}, [this.data.name]),
                            eotwJSXFactory('p', null, [this.data.position])
                        ])
                    ]),
                    eotwJSXFactory('div', {className: "modal__content content-section js-hubspot-form"}, [
                        eotwJSXFactory('h2', {className: "heading heading--2"}, [this.translations.title, " ", this.data.name]),
                        eotwJSXFactory('p', null, [this.translations.text, " ", this.data.name, "."]),
                        eotwJSXFactory('div', {className: "js-hubspot-container hubspot-container", 'data-hubspot-class': "contact", 'data-portal-id': "2188024", 'data-form-id': this.data['hubspot_form_id']})
                    ])
                ])
            ])
        );
    }

    show() {
        super.show();

        handleHubspotForm(this.$modal.find('.js-hubspot-form'));
    }
}


